/** Friendly labels for CS audit artifacts (admins are not developers). */
export const ARTIFACT_KIND_META = {
  request: {
    label: 'Request',
    description: 'What was asked for — inputs the admin submitted.',
    color: 'default',
  },
  dry_run: {
    label: 'Query results',
    description:
      'What the system found before applying anything (preview / dry-run).',
    color: 'info',
  },
  result: {
    label: 'Result',
    description: 'What actually happened after the action ran.',
    color: 'success',
  },
}

/** Friendly action type labels for the audit browser. */
export const ACTION_TYPE_LABELS = {
  INVENTORY_WIPE: 'Inventory wipe',
  QTY_ADJUST: 'Quantity adjust',
  PRICE_ADJUST: 'Price adjust',
  BULK_ADJUST: 'Bulk adjust',
  REPORTS_VIEW: 'Reports verification',
  PRICE_RCA: 'Price RCA',
  DATA_LOOKUP: 'Data lookup',
  EXPORT: 'Export',
  CUSTOMER_BULK_IMPORT: 'Customer CSV import',
}

export function actionTypeLabel(actionType) {
  const key = String(actionType || '')
  return ACTION_TYPE_LABELS[key] || key || '—'
}

export function artifactKindMeta(kind) {
  const key = String(kind || '').toLowerCase()
  return (
    ARTIFACT_KIND_META[key] || {
      label: kind || 'Artifact',
      description: 'Supporting detail for this action.',
      color: 'default',
    }
  )
}

/** Prefer inline action payloads so we do not need a blank-tab S3 open. */
export function resolveArtifactPayload(action, kind) {
  const key = String(kind || '').toLowerCase()
  if (key === 'request') return action?.request_payload ?? null
  if (key === 'dry_run') return action?.dry_run_result ?? null
  if (key === 'result') return action?.result_summary ?? null
  return null
}
